import { Observable } from 'rxjs';


export abstract class DefaultManufacturersAdapter {
  abstract setDefaultManufacturers(
    defaultManufacturers: string
  ): Observable<void>;
}
